<script lang="ts">
	// let { blok }: Props = $props()
</script>
